import { Component, Inject, Vue } from 'vue-property-decorator';
import JunkItHeader from '@/components/header/junk-it-header.vue'
import JunkItFooter from '@/components/footer/junk-it-footer.vue'
import CheckAddress from '@/components/check-address/check-address.vue'; // @ is an alias to /src

@Component({
	components: {
		CheckAddress,
		JunkItHeader,
		JunkItFooter,
	},
})
export default class Home extends Vue {
}
